import styled from 'react-emotion';

export const Title = styled.div`
	color: ${props => props.theme.color};
	display: inline-block;
	font-size: 1.5rem;
	font-weight: bold;
	margin-right: 0.5rem;

	strong {
		padding-right: 0.75rem;
	}

	span {
		display: inline-block;
		font-size: 1rem;
		font-weight: 400;
	}
	
	@media (max-width: 480px) {
		text-align: left;
	}
`

export const Circle = styled.div`
	background: ${props => props.theme.color};
	border-radius: 50%;
	display: inline-block;
	margin: 0 0.5rem 0 1.5rem;
	height: 2rem;
	vertical-align: middle;
	width: 2rem;
`

export const Name = styled.div`
	display: inline-block;
	vertical-align: middle;
`

export const Graph = styled.a`
	color: inherit;
	display: block;
	float: left;
	line-height: 2;
	margin-top: 0.75rem;
	width: 33.33%;

	&:hover ${Name} {
		text-decoration: underline;
	}
`

export const Link = styled.div`
	clear: both;
	font-size: 0.875rem;
	padding-top: 1rem;
	text-align: center;

	${Title} + & {
		clear: none;
		display: inline-block;
		margin-bottom: 2rem;
		padding-top: 0;
	}

	a {
		color: ${props => props.theme.color};
	}
`
